import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AppStore } from '../../app.store';
import { TICKET_SELLING_BASE_URL } from '../../modules/admin-ticket-selling/navigation/ticket-selling-navigation.models';
import { DashboardType } from 'in-time-core';
import { logError } from 'in-time-logger';
import { BusinessMembershipCache } from '../../cache/business-membership-cache';

export const rootGuard: CanActivateFn = async () => {
  const appStore = inject(AppStore);
  const membershipCache = inject(BusinessMembershipCache);
  const router = inject(Router);

  if(!appStore.isAuthenticated()) {
    return router.createUrlTree([ '/login' ]);
  }

  try {
    const membership = membershipCache.getLastOpened();
    if(membership != null) {
      const dashboardType = membership.dashboardType;
      const membershipId = membership.uniqueId;

      if(dashboardType === DashboardType.Ticket) {
        return router.createUrlTree([ TICKET_SELLING_BASE_URL, membershipId ]);
      }
    }
  }
  catch(error) {
    logError('Error while parsing last open membership from local storage:', error);
  }

  return router.createUrlTree([ '/welcome' ]);
};
